import { put } from '@/api/v2';

export const updatePreferredDeliveryPoint = (deliveryPointEntityId: string) =>
  put<void>(
    'user/me/deliverypoint',
    { deliveryPointEntityId },
    { responseHandler: () => () => undefined }
  );
